<template>
  <div>
    <!-- Sous 768 px le tableau passe en mode empilé et son en-tête (qui
         contient le bouton d'ajout version bureau) est masqué : on affiche
         alors le bouton au-dessus du tableau, avec son propre modal. -->
    <div class="d-md-none text-right mb-2">
      <ProductModalAdd @ok="refreshAfterAdd" :id="id" :categories="categories" :host="host"
        modal-suffix="-Mobile" />
    </div>
    <div class="table-responsive datatable-vue" v-if="Data">
      <b-modal :ref="'alertdelete'+SiteID" title="Confirmation" @ok="deleteRow()">
        <p class="my-4">Are you sure to delete this product ? {{ selectedProductID }}</p>
      </b-modal>
      <b-modal :ref="'alertbulkdelete'+SiteID" title="Confirmation" @ok="bulkDelete">
        <p class="my-4">Are you sure to delete {{ selectedCount }} selected product(s) ? This cannot be undone.</p>
      </b-modal>
      <!-- Filtres de la liste + suppression en masse -->
      <div class="d-flex flex-wrap align-items-center mb-2">
        <b-form-input
          v-model="searchQuery"
          type="search"
          placeholder="Search by title"
          class="w-auto mr-2 mb-2 mb-md-0"
          style="min-width: 180px;"
          @input="currentPage = 1"
        ></b-form-input>
        <b-form-select
          v-model="categoryFilter"
          :options="categoryOptions"
          class="w-auto mr-2 mb-2 mb-md-0"
          @change="currentPage = 1"
        ></b-form-select>
        <b-form-select
          v-model="statusFilter"
          :options="statusOptions"
          class="w-auto mr-2 mb-2 mb-md-0"
          @change="currentPage = 1"
        ></b-form-select>
        <button
          type="button"
          class="btn btn-light btn-sm mr-2 mb-2 mb-md-0"
          v-if="searchQuery || categoryFilter || statusFilter !== ''"
          @click="clearFilters"
        ><feather type="x" size="14" class="mr-1"></feather>Clear</button>
        <span class="ml-auto text-muted small mr-2 mb-2 mb-md-0">{{ filteredData.length }} / {{ Data.length }} products</span>
        <b-button
          variant="danger"
          class="mb-2 mb-md-0"
          :disabled="selectedCount === 0"
          @click="confirmBulkDelete"
        ><feather type="trash-2" size="14" class="mr-1"></feather>Delete selected ({{ selectedCount }})</b-button>
      </div>
      <b-table
        ref="tableProducts"
        sticky-header
        striped
        hover
        responsive
        class="text-center"
        bordered
        head-variant="light"
        show-empty
        stacked="md"
        :items="filteredData"
        :fields="tablefields"
        :current-page="currentPage"
        :per-page="perPage"
        :select-mode="selectMode"
        :selectable="true"
      >
        <template v-slot:head(selected)>
          <b-form-checkbox
            :checked="allFilteredSelected"
            :indeterminate="someFilteredSelected && !allFilteredSelected"
            @change="toggleSelectAll"
          ></b-form-checkbox>
        </template>
        <template v-slot:cell(selected)="item">
          <b-form-checkbox v-model="item.item.selected"></b-form-checkbox>
        </template>
       <template v-slot:cell(firstIMG)="item" >
          <img
            height="50px"
            :src="item.item.FirstImage"
            width="50px"
          />
        </template>
        <template #cell(status)="field">
            <div
              v-if="field.item.status ===false"
              class="badge badge-glow badge-danger"
            >
              Disabled
            </div>
            <div
              v-if="field.item.status ===true"
              class="badge badge-glow badge-success"
            >
              Enabled
            </div>
        </template>
        <template v-slot:cell(actions)="item">
          <div class="row-actions">
            <span @click="getIndex(id)">
              <ProductModalEdit @ok="refreshAfterEdit" :SiteID="id" :ProductID="item.item.id" :Data="item.item" :categories="categories" :host="host"/>
            </span>
            <button type="button" class="icon-btn icon-btn-danger" title="Delete product" @click="onDelete(item.item.id)">
              <feather type="trash-2" size="16"></feather>
            </button>
          </div>
        </template>
        <template v-slot:head(actions)>
          <ProductModalAdd @ok="refreshAfterAdd" :id="id" :categories="categories" :host="host"/>
        </template>
      </b-table>
    </div>
    <b-col md="12" class="my-1 pagination-justify p-0">
      <b-pagination
          v-model="currentPage"
          :total-rows="filteredData.length"
          :per-page="perPage"
          aria-controls="my-table"
          class="mt-4"
        ></b-pagination>
    </b-col>
    <div>
      <button type="button" class="btn btn-light mr-2" @click="GenerateCSV"><feather type="download" size="14" class="mr-1"></feather>Generate CSV & TSV Files</button>
    </div>
  </div>
</template>

<script>
import firebase from '@/utils/firestore-shim';
import ProductModalAdd from "./ProductModalAdd.vue";
import ProductModalEdit from "./ProductModalEdit.vue";
export default {
  components:{ ProductModalAdd, ProductModalEdit },
  props: ["id","categories","currency","host"],
  data() {
    return {
      tablefields: [
        { key: "selected", label: "" },
        { key: "title", label: "Title", sortable: true },
        { key: "firstIMG", label: "Image", sortable: true },
        { key: "price", label: "price", sortable: true },
        { key: "compare_at_price", label: "Compare at", sortable: true },
        { key: "stock", label: "Stock", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "actions" }
      ],
      searchQuery: "",
      categoryFilter: null,
      statusFilter: "",
      statusOptions: [
        { value: "", text: "All statuses" },
        { value: "true", text: "Enabled" },
        { value: "false", text: "Disabled" }
      ],
      currentPage: 1,
      perPage: 50,
      pageOptions: [10, 50, 100],
      item: "",
      selectedProductID : "",
      index: null,
      selectMode: "single",
      Data:[],
      facebook:[],
      google:[]
    };
  },
  created() {

  },
  computed: {
    SiteID(){
      return this.id;
    },
    // Produits après application des filtres (les données sont déjà toutes
    // chargées côté client : le filtrage reste instantané).
    filteredData() {
      let items = this.Data;
      const q = String(this.searchQuery || "").trim().toLowerCase();
      if (q) {
        items = items.filter((e) => String(e.title || "").toLowerCase().includes(q));
      }
      if (this.categoryFilter) {
        items = items.filter((e) => e.category === this.categoryFilter);
      }
      if (this.statusFilter !== "") {
        const wanted = this.statusFilter === "true";
        items = items.filter((e) => Boolean(e.status) === wanted);
      }
      return items;
    },
    selectedCount() {
      return this.Data.filter((e) => e.selected).length;
    },
    allFilteredSelected() {
      const rows = this.filteredData;
      return rows.length > 0 && rows.every((e) => e.selected);
    },
    someFilteredSelected() {
      return this.filteredData.some((e) => e.selected);
    },
    // Catégories du site, complétées par celles réellement présentes dans
    // les produits (une catégorie retirée du site peut y rester référencée).
    categoryOptions() {
      const options = [{ value: null, text: "All categories" }];
      const seen = new Set();
      (this.categories || []).forEach((e) => {
        const name = e && e.category;
        if (name && !seen.has(name)) {
          seen.add(name);
          options.push({ value: name, text: String(name).toUpperCase() });
        }
      });
      this.Data.forEach((e) => {
        const name = e.category;
        if (name && !seen.has(name)) {
          seen.add(name);
          options.push({ value: name, text: String(name).toUpperCase() });
        }
      });
      return options;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    selectedRows() {
      return this.listProducts.filter(item => item.delete);
    }
  },
  mounted() {   
    this.Data = this.getProductsData();
  },
  methods: {
    getProductsData() {
      let listData=[];
        var ProductRef = firebase.firestore().collection("Sites").doc(this.SiteID).collection("Products")
        .get().then((e) => {
          e.forEach((doc) => {
            let element = {};
            element=doc.data();
            element.id = doc.id;
            element.selected = false;
            //element.firstIMG = doc.data().images[0].src || null;
            listData.push(element);
          }); 
        });
        return listData;
    },
    getIndex(id) {
      this.selectedProductID = id;
    },
    async deleteRow() {
      let fs = firebase.firestore();
      await fs.collection('Sites').doc(this.SiteID).collection("Products").doc(this.selectedProductID).delete().then(() => {
        this.Data = this.Data.filter((e) => e.id != this.selectedProductID);
        this.$refs.tableProducts.refresh();
      }).catch(function(error) {

      });
    },
    toggleSelectAll(checked) {
      this.filteredData.forEach((e) => {
        this.$set(e, "selected", Boolean(checked));
      });
    },
    confirmBulkDelete() {
      this.$refs['alertbulkdelete' + this.SiteID].show();
    },
    async bulkDelete() {
      const ids = this.Data.filter((e) => e.selected).map((e) => e.id);
      if (!ids.length) return;
      const fs = firebase.firestore();
      const products = fs.collection('Sites').doc(this.SiteID).collection('Products');
      // Firestore limite un lot d'écritures à 500 : les très grosses
      // sélections sont supprimées en plusieurs batchs.
      for (let i = 0; i < ids.length; i += 500) {
        const batch = fs.batch();
        ids.slice(i, i + 500).forEach((id) => batch.delete(products.doc(id)));
        await batch.commit();
      }
      this.Data = this.Data.filter((e) => !e.selected);
      this.$refs.tableProducts.refresh();
    },
    clearFilters() {
      this.searchQuery = "";
      this.categoryFilter = null;
      this.statusFilter = "";
      this.currentPage = 1;
    },
    onSave(id) {

    },
    onDelete(id){
      this.selectedProductID = id;
      this.$refs['alertdelete'+this.SiteID].show();
    },
    doCancel(id) {

    },
    addRecord() {

    },
    searchData() {

    },
    onEdit(id) {

    },
    refreshAfterAdd(e){
      if (e && e.selected === undefined) this.$set(e, "selected", false);
      this.Data.push(e);
      this.$refs.tableProducts.refresh();
      
    },
    refreshAfterEdit(){
      this.$refs.tableProducts.refresh();
    },
    GenerateCSV(){
      this.Data.forEach((e)=>{
          this.facebook.push({
            'id':e.id,
            'title':e.title,
            'description':this.convertHtmlToText(e.description),
            'availability':'in stock',
            'condition':'new',
            'price':this.currency + e.price,
            'link':'https://'+this.host+'/product/'+e.id,
            'image_link':e.FirstImage,
            'additional_image_link':'',
            'age_group':'',
            'color':'',
            'gender':'',
            'item_group_id':'',
            'google_product_category':'',
            'material':'',
            'pattern':'',
            'product_type':e.category,
            'sale_price':this.currency+e.compare_at_price,
            'sale_price_effective_date':'',
            'shipping':'',
            'shipping_weight':'',
            'size':'',
            'custom_label_0':'',
            'custom_label_1':'',
            'custom_label_2':'',
            'custom_label_3':'',
            'custom_label_4':'',
            'brand':e.brand || 'DM',
            'gtin':'',
            'identifier_exists':'false',
            'fb_product_category':e.category
          });
          this.google.push({
            'id':e.id,
            'title':e.title,
            'description':this.convertHtmlToText(e.description),
            'availability':'in stock',
            'condition':'new',
            'price':this.currency + e.price,
            'link':'https://'+this.host+'/product/'+e.id,
            'image_link':e.FirstImage,
            'additional_image_link':'',
            'age_group':'',
            'color':'',
            'gender':'',
            'item_group_id':'',
            'google_product_category':e.category,
            'material':'',
            'pattern':'',
            'product_type':e.category,
            'sale_price':this.currency+e.compare_at_price,
            'sale_price_effective_date':'',
            'shipping':'',
            'shipping_weight':'',
            'size':'',
            'custom_label_0':'',
            'custom_label_1':'',
            'custom_label_2':'',
            'custom_label_3':'',
            'custom_label_4':'',
            'brand':'-',
            'gtin':'UPC',
            'mpn':'',
            'identifier_exists':'false'
        });
      }); 
        this.CsvDownload(this.convertArrayOfObjectsToCSV(this.facebook),'facebook.csv');
        this.TsvDownload(this.convertArrayOfObjectsToCSV(this.google),'google.tsv');
    },
    convertArrayOfObjectsToCSV(args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;

      data = args;
      if (data == null || !data.length) {
      return null;
      }

      columnDelimiter = args.columnDelimiter || ',';
      lineDelimiter = args.lineDelimiter || '\n';

      keys = Object.keys(data[0]);

      result = '';
      result += keys.join(columnDelimiter);
      result += lineDelimiter;

      data.forEach((item) => {
      ctr = 0;
      keys.forEach((key) => {
      if (ctr > 0) result += columnDelimiter;

      result += item[key];
      ctr++;
      });
      result += lineDelimiter;
      });
 
      return result;
    },
    CsvDownload(csv, filename){
      var pom = document.createElement('a');
        var csvContent=csv;
        var blob = new Blob([csvContent],{type: 'text/csv;charset=utf-8;'});
        var url = URL.createObjectURL(blob);
        pom.href = url;
        pom.setAttribute('download', filename);
        pom.click();
    },
    TsvDownload(tsv, filename){
      var pom = document.createElement('a');
        var csvContent=tsv;
        var blob = new Blob([csvContent],{type: 'text/tsv;charset=utf-8;'});
        var url = URL.createObjectURL(blob);
        pom.href = url;
        pom.setAttribute('download', filename);
        pom.click();
    },
    convertHtmlToText(myHTML){
      return myHTML.replace(/<[^>]+>/g, '');
    }
  }
};
</script>

<style lang="scss" scoped>
table.text-center * {
  text-align: center;
}
</style>